<template>
    <Heading>{{ user.login }}</Heading>

    <table class="user-actions-table">
        <tr>
            <td>
                <i class="fa-solid fa-calendar"></i> {{ $t("Signup date") }}
            </td>
            <td>
                {{ user.create_time }}
            </td>
        </tr>
        <tr>
            <td>
                <i class="fa-solid fa-envelope"></i> Email
            </td>
            <td>
                {{ user.obfuscated_email }}
            </td>
        </tr>
        <tr>
            <td>
                <i class="fa-solid fa-trash"></i> {{ $t("Delete character code") }}
            </td>
            <td>
                <Button @click="requestCancellationCode">{{ $t("Request") }}</Button>
            </td>
        </tr>
        <tr>
            <td>
                <i class="fa-solid fa-lock"></i> {{ $t("Safebox password") }}
            </td>
            <td>
                <Button @click="resetSafeboxPassword">{{ $t("Reset") }}</Button>
            </td>
        </tr>
    </table>

    <div class="mt-16">
        <Heading>{{ $t("Characters") }}</Heading>

        <div class="grid grid-cols-2 sm:grid-cols-5 gap-6">
            <div v-for="player in props.players">
                <CharacterCard :player="player"/>
            </div>
        </div>
    </div>

</template>

<script setup>
import Heading from "@/Shared/Heading";
import Button from "@/Shared/Button";
import {Inertia} from '@inertiajs/inertia'
import CharacterCard from "@/Shared/CharacterCard";

const props = defineProps({
    user: Object,
    players: Object
})

function resetSafeboxPassword() {
    Inertia.post(route('user.reset_safebox_password'), {}, {
        preserveScroll: true
    })
}

function requestCancellationCode() {
    Inertia.post(route('user.request_cancellation_code'), {}, {
        preserveScroll: true
    })
}
</script>
